<template>
  <custom-dialog v-drag-dialog :title="model.title" :visible="visible" v-on="$listeners" width="1100px" class="select-event-dialog" :appendToBody="true">
    <div class="dialog-body">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
            <search-input :placeholder="$t('asm_select_event_dialog.bjmcbjbhsjdmsjmc')" v-model="formSearch.searchKey" @fetch="onSearch" width="320px"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <custom-table
        height="400px"
        index
        :data="tableList"
        :tableCode="tableCode"
        v-model="selectedData"
        type="checkbox"
        @filter="filterChange"
        @sort="sortChange"
        ref="table"
        @select="onSelect"
      ></custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button :disabled="!selectedData.length" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis.js';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      tableCode: 'paramset_select_event',
      formSearch: {
        searchKey: '',
        pageSize: 50,
        pageNum: 1,
        // eventClass: '2',
        // eventType: '23',
      },
      tableList: [],
      selectedData: [],
      totalRows: null,
    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectedData);
    },
    onSearch() {
      this.formSearch.pageNum = 1;
      this.getTableList();
    },
    getReqData() {
      return {
        ...this.formSearch,
        productCode: this.model.data.productCode,
      };
    },
    getTableList() {
      this.$getJSON(apis.eventPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onSelect(selection, row) {
      this.tableList.forEach((_) => {
        if (_.eventId !== row.eventId) {
          this.$refs.table.$refs.tb1.toggleRowSelection(_, false);
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss">
.select-event-dialog {
  .dialog-body {
    padding-top: 0 !important;
  }

  .el-table__fixed-header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    display: none;
  }
}
</style>
